import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginateQuery, PaginatorModel } from 'symbols';
import { CodeStatusModel } from './symbols';

@Injectable()
export class CodeStatusService {

  apiUrl = '/api/status-code';

  constructor(private http: HttpClient) {
  }

  getCodeStatusList(filter: PaginateQuery<{ search: string }>) {
    const params: any = {};
    params['search'] = filter.filter?.search || '';
    return this.http.get<PaginatorModel<CodeStatusModel>>(this.apiUrl, { params });
  }
}
